import { render, staticRenderFns } from "./DialogImg.vue?vue&type=template&id=072d3bd7&"
import script from "./DialogImg.vue?vue&type=script&lang=js&"
export * from "./DialogImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports